import axios from 'axios';
import axiosInterceptor from './axiosInterceptor';
import { environment } from './environment';

const wampServer = environment.API_AUTHEN;
const apiAuthenticate = axios.create({
   baseURL: wampServer,
});
axiosInterceptor.setupInterceptors(apiAuthenticate);
export default apiAuthenticate;
